<template>
  <div class="container">
    <Header></Header>
    <div class="dWrap">
      <div class="content" v-if="emailData">
        <div class="m_title">{{ emailData[$route.params.tno].title }}</div>
        <div class="detail">
          <div class="d-content">
            <p class="email">{{ emailData[$route.params.tno].title }}：{{ emailData[$route.params.tno].email }}</p>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  data() {
    return {
      emailData: [
        {
          title: ' 业务咨询邮箱',
          email: 'gdgpa03@163.com '
        },
        {
          title: '会长邮箱',
          email: 'gdgpa01@163.com'
        },
        {
          title: '秘书长邮箱',
          email: 'gdgpa02@163.com '
        }
      ]
    };
  },
  mounted() {},
  methods: {
    close() {
      window.close();
    },
    print() {
      window.print();
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1198px;
  .dWrap {
    width: 1124px;
    padding: 0 14px;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
  }
  .content {
    padding: 20px 0 70px;
    .m_title {
      position: relative;
      padding: 23px 0;
      text-align: center;
      font-size: 32px;
      color: #000000;
      border-bottom: 1px solid #013f99;
      &:after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        width: 84px;
        height: 4px;
        background: #013f99;
      }
    }
    .d-title {
      padding: 35px 0 0;
      p {
        line-height: 42px;
        text-align: center;
        font-size: 24px;
        color: #000000;
        &.author {
          font-size: 16px;
          padding: 14px 0 0;
          line-height: 36px;
        }
      }
    }
    /deep/.detail {
      padding: 0 18px;
      overflow: hidden;
      white-space: pre-wrap;
      * {
        max-width: 100%;
        word-break: break-all;
        word-wrap: break-word;
        box-sizing: border-box;
      }
      .d-content {
        padding: 20px 40px 30px;
        p.email {
          color: #333;
          font-size: 30px;
          font-weight: 600;
          padding: 60px 0 20px 0;
        }
      }
    }
    .ctrl {
      padding: 30px 0 0;
      text-align: center;
      font-size: 16px;
      color: #000000;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
